export type TaskEventType = 'Start' | 'Pause' | 'Resume' | 'Stop';

export default interface TaskEvent extends OperatorNote {
    id: string;
    type: TaskEventType;
    time: string;
}

export interface OperatorNote {
  operatorNoteReason: OperatorNoteReason | null;
  operatorNote: string | null;
}

export enum OperatorNoteReason {
  "Waiting for materials" = 1,
  "Waiting for operator/engineer" = 2,
  "Machine breakdown" = 3,
  "Cleaning/Repairing change parts" = 4,
  "Locating change parts" = 5,
  "Shift handover" = 6,
  "Fire alarm / Site event" = 7,
  "Other" = 999,
}
